








































import Vue from 'vue';
import {RoutsData} from '../router/routs';
import {ChannelApi} from '../api/channel-api';
import {Channel} from '../types/channel';
import {VideoChannelApi} from '@/api/video-channel-api';
import {VideoChannel} from '@/types/video-channel';

export default Vue.extend({
  name: 'VideoChannelList',
  beforeMount() {
    this.getData();
  },
  data() {
    return {
      channels: [] as VideoChannel[],
      load: false,
      addChannel: {name: RoutsData.VIDEO_CHANNEL_ADD.name}
    };
  },
  methods: {
    async getData() {
      this.load = true;
      VideoChannelApi.getList().then(res => this.channels = res.data).finally(() => this.load = false);
    }
  }
});
